import { ReserveTime } from '../../../models/reserve.entity';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3 } from '../../http';

/** Park Mode 协议版本（amusement agreement-versions） */
export interface AgreementVersion {
    /** 协议展示名 */
    agreement_name: string;
    /** 协议类型（如 TERMS_OF_USE / PRIVACY_POLICY / DISCLAIMER） */
    agreement_type: string;
    /** 是否允许删除 */
    can_delete: boolean;
    /** 是否允许修改 */
    can_modify: boolean;
    /** 正文：标题 + HTML */
    content: {
        /** 条款标题 */
        title: string;
        /** 富文本 HTML */
        content: string;
    };
    /** 内容哈希 */
    content_hash: string;
    /** 创建时间 */
    created_at: string;
    /** 是否已有签署记录（有则保存需发新版） */
    has_signed_record: boolean;
    /** 版本记录 id */
    id: number;
    /** 是否为当前生效版本 */
    is_current: boolean;
    /** 是否被引用 */
    is_referenced: boolean;
    /** 语言 */
    language: string;
    /** 版本号字符串 */
    version: string;
    /** 版本序号 */
    version_seq: number;
}

/** 协议版本列表响应 */
export type AgreementVersionListResponse = {
    /** 是否成功 */
    ok: boolean;
    /** 版本列表 */
    versions: AgreementVersion[];
};

const reserveApi = {
    /**
     * 查询预定配置时间段
     */
    async get_reserve_hour(): Promise<any> {
        return await http.get(`${BASE_URL_3}/reserve_hour/${getRBPStringId()}`);
    },

    /**
     * 修改/新增预定配置时间段
     */
    async post_reserve_hour(reserveTimes: Array<ReserveTime>, deleteIds: number[] = []): Promise<any> {
        return await http.post(`${BASE_URL_3}/reserve_hour/${getRBPStringId()}`, {
            data: reserveTimes,
            ids: deleteIds,
        });
    },

    /**
     * 删除预定配置时间段
     */
    async delete_reserve_hour(ids: Array<number>): Promise<any> {
        return await http.delete(`${BASE_URL_3}/reserve_hour/${getRBPStringId()}`, { data: ids });
    },

    /**
     * 获取 Park Mode 条款版本列表
     * `GET /v3/amusement/agreement-versions/{string_id}`
     */
    async get_park_mode_agreement_versions(): Promise<AgreementVersionListResponse> {
        return await http.get(`${BASE_URL_3}/amusement/agreement-versions/${getRBPStringId()}`);
    },

    /**
     * 创建新版本并发布为当前版本
     * `POST /v3/amusement/agreement-versions/{string_id}`
     * @param data - agreement_type + stringified content
     */
    async post_park_mode_agreement_version(data: {
        agreement_type: string;
        content: string;
    }): Promise<any> {
        return await http.post(`${BASE_URL_3}/amusement/agreement-versions/${getRBPStringId()}`, data);
    },

    /**
     * 修改未签署记录的当前版本
     * `PATCH /v3/amusement/agreement-versions/{id}/{string_id}`
     * @param id - 版本记录 id
     * @param data - agreement_name + stringified content
     */
    async patch_park_mode_agreement_version(
        id: number,
        data: {
            agreement_name: string;
            content: string;
            is_current?: boolean;
        },
    ): Promise<any> {
        return await http.patch(
            `${BASE_URL_3}/amusement/agreement-versions/${id}/${getRBPStringId()}`,
            data,
        );
    },

    /**
     * 删除协议版本
     * `DELETE /v3/amusement/agreement-versions/{id}/{string_id}`
     * @param id - 版本记录 id
     */
    async delete_park_mode_agreement_version(id: number): Promise<any> {
        return await http.delete(
            `${BASE_URL_3}/amusement/agreement-versions/${id}/${getRBPStringId()}`,
        );
    },
};

export default reserveApi;
